function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
const TranslationJob = require("../../models/translation-job");
const { normalizePath } = require("../../services/url-service/url-service");
const { CurrentPageVersion, PAGE_ID_FIELD_NAME } = require("../../models/current-page-version");
const { initLogger } = require("../logger-service/logger-service");
const { TranslationStatus } = require("../../../constants/translations/translation-jobs");
const { normalizeUrlForCanonical } = require("../../../utils/url");
const logger = initLogger();
const MONDAY_BASE_PATH = process.env.MONDAY_BASE_PATH;
const getTranslatedLanguages = function() {
    var _ref = _async_to_generator(function*(paths) {
        try {
            const aggregations = [
                {
                    $match: {
                        path: {
                            $in: paths
                        }
                    }
                },
                {
                    $group: {
                        _id: "$path",
                        path: {
                            $first: "$path"
                        },
                        languages: {
                            $addToSet: {
                                $concat: [
                                    "$language"
                                ]
                            }
                        }
                    }
                }
            ];
            const translations = yield TranslationJob.aggregate(aggregations);
            return translations;
        } catch (e) {
            logger.error(e);
            return [];
        }
    });
    return function getTranslatedLanguages(paths) {
        return _ref.apply(this, arguments);
    };
}();
const updateTranslationJobOnPublish = function() {
    var _ref = _async_to_generator(function*(translationJobId) {
        try {
            yield TranslationJob.findByIdAndUpdate(translationJobId, {
                translationStatus: TranslationStatus.DONE
            });
        } catch (e) {
            logger.error(e);
        }
    });
    return function updateTranslationJobOnPublish(translationJobId) {
        return _ref.apply(this, arguments);
    };
}();
const getPageLocales = function() {
    var _ref = _async_to_generator(function*(path) {
        try {
            const normalizedPath = normalizePath(path);
            const currentVersion = yield CurrentPageVersion.findOne({
                path: normalizedPath
            }).populate(PAGE_ID_FIELD_NAME);
            if (!currentVersion) return [];
            const currentVersions = yield CurrentPageVersion.aggregate([
                {
                    $match: {
                        pageId: currentVersion.pageId._id
                    }
                },
                {
                    $project: {
                        path: "$path",
                        locale: "$locale"
                    }
                }
            ]);
            const locales = [
                {
                    path: currentVersion.pageId.path,
                    locale: "x-default"
                },
                ...currentVersions
            ];
            const result = locales.map(({ locale, path })=>({
                    path: normalizeUrlForCanonical(path),
                    locale
                }));
            return result;
        } catch (e) {
            logger.error(e);
            return [];
        }
    });
    return function getPageLocales(path) {
        return _ref.apply(this, arguments);
    };
}();
module.exports = {
    getTranslatedLanguages,
    updateTranslationJobOnPublish,
    getPageLocales
};
